export const createFullAddress = (entity = {}) => {
	const streetName = entity.streetName?.trim();

	const corpus = entity.corpus ? `к.${entity.corpus.trim()}` : '';
	const buildingBlock = [entity.building?.trim(), corpus].filter(Boolean).join(' ');

	const roomType = entity.addressTypeShort?.trim();
	const roomBlock = [roomType, entity.flat?.trim()].filter(Boolean).join(' ');

	return [streetName, buildingBlock, roomBlock].filter(Boolean).join(', ')
}